import { Stack } from '@chakra-ui/react'

import CustomFormEmptyAnswerFeedback from 'components/tools/CustomForm/commonComponents/CustomFormEmptyAnswerFeedback'
import CustomFormSelectionItem from 'components/tools/CustomForm/commonComponents/CustomFormSelectionItem'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'

export default function CustomFormMultipleSelectionBoxAnswer() {
  const { answer } = useCustomFormAnswer()

  return (
    <CustomFormEmptyAnswerFeedback>
      <Stack spacing={[1, 1, 1, 2, 2, 2]} direction="column" align="flex-start">
        {(answer?.answer || []).map((option: any, index) => {
          const scoreSettingsOptions = answer?.score_settings?.options
          const hasScore = answer?.has_score
          const hasAnswer = answer?.answer?.includes(option)
          const answerScoreSettings = hasScore && scoreSettingsOptions ? scoreSettingsOptions[index] : []
          const scoreOptionKeyValue = hasScore ? answerScoreSettings.value : ''

          return (
            <CustomFormSelectionItem
              key={option}
              hasAnswer={hasAnswer}
              hasScore={hasScore}
              option={option}
              scoreOptionKeyValue={scoreOptionKeyValue}
            />
          )
        })}
      </Stack>
    </CustomFormEmptyAnswerFeedback>
  )
}
